import React from 'react';
import type { FC } from 'react';

import CurrencyFormat from 'src/components/CurrencyFormat';
import InstantIcon from '@lt/components/icons-react/rebrand/Instant';

import styles from './summary.module.css';

interface SummaryProps {
  instantConfirm?: boolean;
  value?: number;
}

const Summary: FC<SummaryProps> = ({ instantConfirm, value = 0 }) => (
  <div className={styles.root}>
    {instantConfirm && <InstantIcon className={styles.instantIcon} />}
    <CurrencyFormat className={styles.price} value={value} />
  </div>
);

export default Summary;
